<template>
  <v-menu :nudge-width="120" size="12" v-if="multipleProviders || multipleBranchOffices">

    <template v-slot:activator="{on}">
      <v-btn dark  text small v-on="on" class="px-2" active-class="active-menu">
          <v-icon size="18" class="mr-1">{{selectedIcon}}</v-icon>
          <span>{{selectedAccountInitials}}</span>
      </v-btn>
    </template>

    <v-list two-line subheader>

      <template v-for="(provider, i) in filteredProviders">

        <template v-if="provider.type === 'individual'" >
          <v-list-item @click="setCurrentProvider({provider})" :key="`prov-${provider.id}`">
            <v-list-item-title>
              <v-icon :color="currentProvider && currentProvider.id === provider.id ? 'primary': 'black'" size="18" class="pr-2">fa-user</v-icon>
              <span :class="currentProvider.id && currentProvider.id === provider.id ? 'primary--text': ''">{{provider.name}}</span>
            </v-list-item-title>
          </v-list-item>
        </template>

        <template v-else>
          <v-subheader :key="`provider-header-${provider.id}`" style="font-size: 11px; height: 20px; margin-top: 10px;">{{provider.name}}</v-subheader>
          <v-list-item @click="setBranchOffice(office, provider)"  v-for="office in provider.institution.branch_offices" :key="`off-${office.id}`">
            <v-list-item-title>
              <v-icon :color="currentBranchOffice && currentBranchOffice.id === office.id ? 'primary': 'black'" size="18" class="pr-2">fa-warehouse</v-icon>
              <span :class="currentBranchOffice && currentBranchOffice.id === office.id ? 'primary--text': ''">{{office.name}}</span>
            </v-list-item-title>
          </v-list-item>
        </template>

        <v-divider :key="`provider-divider-${provider.id}`" v-if="i < availableProviders.length - 1"></v-divider>

      </template>


    </v-list>
  </v-menu>
</template>

<script>

import {mapGetters, mapMutations, mapState} from 'vuex'

export default {
  name: "AccountPickerBtn",
  data(){
    return {

    }
  },
  mounted(){
    const vm = this
  },
  computed:{
    ...mapState(['currentUser', 'currentProvider', 'currentBranchOffice', 'branchOffices']),
    ...mapGetters(['availableProviders']),
    filteredProviders(){
      const vm = this
      if(!vm.availableProviders || vm.availableProviders.length === 0){
        return []
      }

      return vm.availableProviders.map(provider => {
        if(!provider.institution) {
          return provider
        }

        const {institution, role} = provider
        const {scope} = role
        const scopedOffices = scope.offices.map(office => office.toString())
        const filteredBranches = scopedOffices.includes('*') ?
            institution.branch_offices :
            institution.branch_offices.filter(office => {
              return scopedOffices.includes(office.id.toString())
            })

        provider.institution.branch_offices = filteredBranches
        return provider

      })


    },
    selectedAccountInitials(){
      const vm = this

      if(!vm.currentProvider  ||
          (vm.currentProvider && vm.currentProvider.type === 'institution' && (
              !vm.currentBranchOffice || !vm.currentBranchOffice.name
          ))) return '-'

      let nameToSplit = vm.currentProvider.type === 'individual' ?
            vm.currentProvider.name : vm.currentBranchOffice.name

      if(nameToSplit.length < 5) return nameToSplit

      const nameSplit = nameToSplit.split(' ')
      let str = nameSplit[0][0]

      if(nameSplit.length > 1){
        str += nameSplit[1][0]
      }

      return str.toUpperCase()

    },
    multipleProviders(){
      const vm = this
      return vm.availableProviders.length > 1
    },
    multipleBranchOffices(){
      const vm = this
      return vm.branchOffices.length > 1
    },
    selectedIcon(){
      const vm = this
      if(!vm.currentProvider) return ''

      if(vm.currentProvider.type === 'individual'){
        return 'fa-user'
      }

      return 'mdi-office-building'

    }
  },
  methods:{
    ...mapMutations(['setCurrentBranchOffice', 'setCurrentProvider']),
    setBranchOffice(office, provider){
      const vm = this
      vm.setCurrentProvider({provider, office})
    }
  }
}
</script>

<style scoped>
>>>.v-list--two-line .v-list__tile {
  height: 45px;
}
</style>
